// extracted by mini-css-extract-plugin
export default {"label":"Label_label__PjNTr","text":"Label_text__DfJJm","required":"Label_required__o9vOn","optional":"Label_optional__wUaO4","icon":"Label_icon__nIaoi"};